import { bool } from 'prop-types';
import React, { useRef } from 'react';
import { Link } from 'react-router-dom';

import HoverDetails from '../../generic/HoverDetails';
import { contactShape } from '../../prop-types';
import { withFullName } from '../../users/utils';
import { fullName } from '../constants';

function ContactLink({ model, verbose, lastNameOnly }) {
  const linkRef = useRef(null);
  const { title, description, email, status, account, merchants, type } = model;
  const merchantsNames =
    merchants?.map(merchant => merchant.name).join(', ') || '-';
  return (
    <>
      <span ref={linkRef}>
        <Link to={`/contacts/${model.id}/show`}>
          {lastNameOnly ? model.lastName : fullName(model)}
        </Link>
        {verbose && <span className="pl-2 small">{model.email}</span>}
      </span>
      <HoverDetails
        size="large"
        linkRef={linkRef}
        title={`${title} ${withFullName(model).fullName}`}
        fields={{
          Description: description,
          Email: email,
          Status: status,
          Account: account?.name,
          Merchants: merchantsNames,
          Type: type,
        }}
      />
    </>
  );
}

ContactLink.propTypes = {
  model: contactShape.isRequired,
  verbose: bool,
  lastNameOnly: bool,
};

ContactLink.defaultProps = {
  verbose: false,
  lastNameOnly: false,
};

export default ContactLink;
